import { gql } from '@apollo/client';

const referToOpcityMutation = gql`
  mutation ReferToOpcityMutation(
    $sellerInputUuid: String!
    $fullName: String!
    $email: String!
    $phoneNumber: String!
  ) {
    webAgentReferral {
      referToOpcity(
        input: {
          sellerInputUuid: $sellerInputUuid
          fullName: $fullName
          email: $email
          phoneNumber: $phoneNumber
        }
      ) {
        result
      }
    }
  }
`;

export default referToOpcityMutation;
